import { RedoNotification } from "@redotech/redo-web/arbiter-components/notification/redo-notification";
import { memo } from "react";
import { OnboardingProps } from "../common";
import * as styles from "./supplies-free-labels-announcement-modal.module.css";
import { useStartSuppliesShopping } from "./use-start-supplies-shopping";

const SUPPLIES_FREE_LABELS_HERO_URL =
  "https://assets.getredo.com/redo-supplies/free-labels-hero.png";

export const SuppliesFreeLabelsAnnouncementModal = memo(
  function SuppliesFreeLabelsAnnouncementModal({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const [shoppingState, startShopping] =
      useStartSuppliesShopping(handleComplete);

    return (
      <div className={styles.notificationHost}>
        <RedoNotification
          breakpoint="mobile"
          buttonAlignment="right"
          darkMode
          dataTestId="supplies-free-labels-announcement"
          description="Spend $200 on supplies by Friday, July 31 and get a free box of labels."
          dismiss={handleDismiss}
          dismissButton={{ text: "Dismiss" }}
          fullModalImage={SUPPLIES_FREE_LABELS_HERO_URL}
          hideCloseX
          primaryButton={{
            onClick: () => startShopping(),
            pending: shoppingState.pending,
            text: "Start shopping",
            theme: "action",
          }}
          title="Claim your free labels by Friday"
        />
      </div>
    );
  },
);
